module.exports = __webpack_public_path__ + "static/img/banner-6.a9442277.png";